module.exports = __webpack_public_path__ + "static/media/arrow-alt-circle-down.6c46e584.svg";